import React from 'react'

function RewardRate({ data }) {
    console.log(data.map(x => x.branch_name))
    console.log(data.map(x => x.rate))
    const RenderList = () => {
        const names = [...data.map(x => x.branch_name) || null]
        const values = [...data.map(x => x.rate) || null]
        return names.map((name, i) => {
            return (
                <div key={i} className={`h-[8vh] w-[90%] mx-auto flex items-center border-b-[1px] px-[16px]`}>
                    {/* {t('credit.credit_details')} */}
                    <div className='w-[47%] text-[#657585] text-[16px] font-[400]'>
                        {name}
                    </div>
                    <div className='w-[47%] text-[#05213D] pl-[50px] text-[16px] font-[400]'>
                        {values[i]}
                    </div>
                </div>
            )
        })
    }

    return (
        <div className=''>
            <RenderList />
        </div>
    )
}

export default RewardRate